// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_TyN","content":"styles_content__ThiB9"};